/* eslint-disable no-unused-vars */
import { useMemo } from 'react';
import { addFieldStatus } from 'utils';
import {
  AppStatusPreview,
  CopyString,
  ImageWithFallback,
  ParagraphWithTooltip,
  Separators,
} from 'components';
import * as S from './PreviewApp.styled';
import { useParams } from 'react-router';
import { manageAppsAPI } from 'services/manageApps.service';
import { subdirectory } from 'utils';
import EmptyIcon from 'assets/images/EmptyIcon.svg';

const PreviewApp = () => {
  const { pba_id } = useParams();
  const { data: previewData } = manageAppsAPI.useFetchAppDataQuery(pba_id);

  let dataWithStatus = useMemo(() => {
    if (previewData) {
      return addFieldStatus([previewData])[0];
    }
  }, [previewData]);

  return (
    <S.Container>
      <S.AppPreview>
        <S.IconWrapper>
          <ImageWithFallback
            src={`https://cdn.appnext.com/${subdirectory(dataWithStatus?.image_url)}/${
              dataWithStatus?.image_url
            }`}
            fallbackSrc={EmptyIcon}
          />
          {dataWithStatus?.app_type_assoc && <S.WwwTag>WWW</S.WwwTag>}
        </S.IconWrapper>
        <AppStatusPreview status={dataWithStatus?.status ?? ''} />
        <S.Label>
          <ParagraphWithTooltip text={dataWithStatus?.pba_name} />
        </S.Label>
        <CopyString label={'ID'} text={dataWithStatus?.pba_number + ''} />
      </S.AppPreview>
      <Separators type={Separators.separatorTypes.small} style={{ margin: '8px 0 16px 0' }} />
    </S.Container>
  );
};

export default PreviewApp;
